import { render, staticRenderFns } from "./Settings-role.vue?vue&type=template&id=1c571322&scoped=true&"
import script from "./Settings-role.vue?vue&type=script&lang=js&"
export * from "./Settings-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c571322",
  null
  
)

export default component.exports